import CollapsibleTransition from './CollapsibleTransition';

export default CollapsibleTransition;